module.exports = __webpack_public_path__ + "img/column-icon.1123ae95.svg";